import { Box } from '@mui/material'
import { IFormLayout } from './types'
import { FC } from 'react'

const FormLayout: FC<IFormLayout> = ({ children, gap = '1.8rem' }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: gap, width: '100%' }}>{children}</Box>
  )
}

export default FormLayout
